// extracted by mini-css-extract-plugin
export default {"header__container":"header_header__container__fzIir","db_logo":"header_db_logo__VTWQq","menu":"header_menu__hQUt3"};